import StatesSmap from '@components/StatesMap';
import WorldMap from '@components/WorldMap';
import React, {useEffect, useState} from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

const Approachmapslider = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const [showWorldMap, setShowWorldMap] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowWorldMap(true);
    }, 1000);

    return () => clearTimeout(timer); // Cleanup on unmount
  }, []);

  return (
    <div className='home-map-wrap p-0 slick-slider-arrow lt-rt-arrow'>
      <div className='container'>
        <div className='row map-head-row-1'>
          <div className='col-md-12 h-map-sec'>
            <Slider {...settings}>
              <div>
                <StatesSmap />
                <div className='map-btminfo-col'>
                  <div>
                    <div className='map-info-title'>States Reached</div>
                    <div className='map-info-sub-title'>
                      *Including D.C. and Puerto Rico
                    </div>
                  </div>
                </div>
              </div>
              {showWorldMap && (
                <div>
                  <WorldMap />
                </div>
              )}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Approachmapslider;
